import type { PluginDefaultTranslationsObject } from '../types.js'

export const sl: PluginDefaultTranslationsObject = {
  '@seshuk/payload-storage-bunny': {
    // TUS Upload
    tusUploadChecking: 'Preverjam prejšnje nalaganja...',
    tusUploadDisableMode: 'Onemogoči TUS način',
    tusUploadEnableMode: 'Omogoči TUS način',
    tusUploadErrorFileType: 'Tip datoteke ni dovoljen',
    tusUploadErrorInitUpload: 'Ni uspešno zagnati nalaganja',
    tusUploadErrorPrevCheckFail: 'Ni uspešno preveriti prejšnja nalaganja',
    tusUploadErrorRestoreUpload: 'Ni uspešno obnoviti nalaganja',
    tusUploadFileSize: '{{size}} MB',
    tusUploadFinalizing: 'Zaključujem...',
    tusUploadPause: 'Pavza',
    tusUploadPreparing: 'Pripravljam nalaganje...',
    tusUploadResume: 'Nadaljuj',
    tusUploadRetry: 'Poskusi znova',
    tusUploadStartOver: 'Začni znova',
    tusUploadStartUpload: 'Začni nalaganje',
    tusUploadStatusChecking: 'Preverjam prejšnja nalaganja...',
    tusUploadStatusCompleted: 'Nalaganje uspešno zaključeno!',
    tusUploadStatusFinalizing: 'Zaključujem nalaganje...',
    tusUploadStatusIdle: 'Pripravljeno za nalaganje',
    tusUploadStatusIdleWithRestore: 'Pripravljeno za nadaljevanje ali začetek znova',
    tusUploadStatusPaused: 'Nalaganje pavzirano na {{progress}}%',
    tusUploadStatusUploading: 'Nalagam... {{progress}}%',
    tusUploadTimeHours: 'h',
    tusUploadTimeMinutes: 'm',
    tusUploadTimeSeconds: 's',

    // Error messages
    errorAccessDenied: 'Nimate dovoljenja za dostop do tega vira',
    errorDeleteFileFailed: 'Ni bilo mogoče izbrisati datoteke: {{filename}}',
    errorMissingRequiredFields: 'Manjkajo nekatere potrebne informacije',
    errorNoServiceConfigured: 'Ni konfigurirana nobena storitev',
    errorStreamConfigMissing: 'Bunny Stream ni pravilno konfiguriran',
    errorTitleRequired: 'Prosimo vnesite naslov vašega videa',
    errorUploadFileFailed: 'Ni bilo mogoče naložiti datoteke: {{filename}}',
  },
}
